<template>
  <marketing-card title="Welcome to myproimages.com">
    <m-heading heme="h2" class="mt-4 text-center font-bold"> Event Online Ordering Platform </m-heading>

    <div class="mt-6 flex flex-col items-center gap-4">
      <div class="divider pt-6"><m-heading heme="h3" class="font-bold"> Studio </m-heading></div>

      <p>Have an account?</p>
      <m-router-link-button theme="link" :to="{ name: LOGIN }"> Studio Login </m-router-link-button>

      <div class="divider"><m-heading heme="h3" class="font-bold"> Customer </m-heading></div>
      <p>Looking for order details?</p>
      <m-form class="w-full" :action-list="{ position: 'center' }" @submit="handleSubmit">
        <m-form-control label="Email" for="email" :error="errors.email">
          <m-input id="email" v-model="model.email" type="text" />
        </m-form-control>
        <m-form-control label="Order #" for="orderNumber" :error="errors.orderNumber">
          <m-input id="orderNumber" v-model="model.orderNumber" type="text" />
        </m-form-control>
        <template #actions>
          <m-button type="submit" width="wide" :loading="loading"> Search </m-button>
        </template>
      </m-form>
    </div>
  </marketing-card>
</template>
<script setup lang="ts">
  import { useRouter } from 'vue-router';
  import MHeading from '@core/components/MHeading/MHeading.vue';
  import MRouterLinkButton from '@shared/components/MLinkButton.vue/MRouterLinkButton.vue';
  import { LOGIN } from '@apps/account/routing';
  import MInput from '@shared/components/MInput/MInput.vue';
  import MForm from '@core/components/MForm/MForm.vue';
  import MFormControl from '@core/components/MFormControl/MFormControl.vue';
  import { useAsyncServiceResult } from '@shared/composables/useAsync';
  import { isServiceSuccess } from '@core/models/actionResponse';
  import { useToaster } from '@core/utils/useToaster';
  import { useFormModel } from '@core/utils/forms/useFormModel';
  import { email, required } from '@core/utils/forms/rules';
  import { useCartStore } from '@apps/customer/stores/cart.store';
  import { ORDER_CONFIRMATION } from '@apps/checkout/routing';
  import { fetchJobDetails } from '@apps/customer/services/jobs.service';
  import MarketingCard from '../components/MarketingCard.vue';
  import { searchCart } from '../services/cartsearch.service';

  const cartStore = useCartStore();
  const router = useRouter();
  const [formState, model, errors] = useFormModel(
    {
      email: '',
      orderNumber: '',
    },
    {
      orderNumber: [required()],
      email: [email],
    },
  );

  const { toastify } = useToaster();

  const { loading, execute: handleSubmit } = useAsyncServiceResult(async () => {
    if (formState.validate().success) {
      const result = await searchCart(model.orderNumber, model.email);
      if (isServiceSuccess(result)) {
        cartStore.setDetails(result.data);
        const studioSlug = (await fetchJobDetails(result.data.jobId!)).studioWebUrl;
        router.push({
          name: ORDER_CONFIRMATION,
          params: {
            studioSlug: studioSlug,
            jobId: result.data.jobId,
            orderNumber: model.orderNumber,
          },
        });
        return result;
      }
      formState.reset();
      toastify(result, undefined, 'Could not find this order');

      return result;
    }
    throw new Error('Form is invalid');
  });
</script>
